import { GetFlightItineraryState } from './getFlightItinerary.types'

const initialState: GetFlightItineraryState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
